import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatDialogRef} from '@angular/material/dialog';
import * as moment from 'moment';
import { FormUtils } from 'src/app/_helpers/form-utils';
import { Store } from 'src/app/_models/store';
import { StoreService } from 'src/app/_services/store.service';

import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss']
})
export class HolidaysComponent implements OnInit {

  holiday_names = [
    "New Year's Day",
    "Martin Luther King Jr. Day",
    "Valentine's Day",
    "Presidents' Day",
    "St. Patrick's Day",
    "Cesar Chavez Day",
    "Easter Sunday",
    "Earth Day",
    "Arbor Day",
    "Cinco de Mayo",
    "Mother's Day",
    "Memorial Day",
    "Juneteenth National Independence Day",
    "Father's Day",
    "Independence Day",
    "Labor Day",
    "Patriot Day",
    "Constitution Day and Citizenship Day",
    "Columbus Day / Indigenous Peoples' Day",
    "Halloween",
    "Veterans Day",
    "Black Friday",
    "Christmas Eve",
    "Christmas Day",
    "New Year's Eve",
    "Thanksgiving Day"
]

  isLoading = false;
  form;
  store:Store;

  hours;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<HolidaysComponent>,
    private formUtils:FormUtils,  
    private storeService: StoreService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
      this.hours = formUtils.buildTimeOptions();
    }

  ngOnInit() {
    this.store = this.data.store;
    this.form = this.formBuilder.array(this.store.holiday_list.map(sh => {
     

      return this.formBuilder.group({
        store_id: this.store.id,
        is_open: sh.is_open,
        holiday_name:sh.holiday_name
      })
    }))

  }

  /**
   * The native dialog's date caption: the holiday's date in the current year, so
   * "Thanksgiving Day" reads "Nov 26, 2026" without the merchant doing the math.
   * Fixed-date holidays are a lookup; floating ones are nth-weekday rules; Easter is the
   * Anonymous Gregorian computus. An unknown name simply shows no caption.
   */
  holidayDate(name: string): string {
    if (!name) { return ''; }
    const date = this.computeHolidayDate(name, new Date().getFullYear());
    return date ? date.format('MMM D, YYYY') : '';
  }

  private nthWeekday(year: number, month: number, weekday: number, n: number) {
    const first = moment({ year, month, day: 1 });
    const offset = (weekday - first.day() + 7) % 7;
    return first.add(offset + (n - 1) * 7, 'days');
  }

  private lastWeekday(year: number, month: number, weekday: number) {
    const last = moment({ year, month, day: 1 }).endOf('month').startOf('day');
    const offset = (last.day() - weekday + 7) % 7;
    return last.subtract(offset, 'days');
  }

  private easterSunday(year: number) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return moment({ year, month, day });
  }

  private computeHolidayDate(name: string, year: number) {
    const fixed: { [key: string]: [number, number] } = {
      "New Year's Day": [0, 1],
      "Valentine's Day": [1, 14],
      "St. Patrick's Day": [2, 17],
      'Cesar Chavez Day': [2, 31],
      'Earth Day': [3, 22],
      'Cinco de Mayo': [4, 5],
      'Juneteenth National Independence Day': [5, 19],
      'Independence Day': [6, 4],
      'Patriot Day': [8, 11],
      'Constitution Day and Citizenship Day': [8, 17],
      'Halloween': [9, 31],
      'Veterans Day': [10, 11],
      'Christmas Eve': [11, 24],
      'Christmas Day': [11, 25],
      "New Year's Eve": [11, 31]
    };
    if (fixed[name]) {
      return moment({ year, month: fixed[name][0], day: fixed[name][1] });
    }
    switch (name) {
      case 'Martin Luther King Jr. Day': return this.nthWeekday(year, 0, 1, 3);
      case "Presidents' Day": return this.nthWeekday(year, 1, 1, 3);
      case 'Easter Sunday': return this.easterSunday(year);
      case 'Arbor Day': return this.lastWeekday(year, 3, 5);
      case "Mother's Day": return this.nthWeekday(year, 4, 0, 2);
      case 'Memorial Day': return this.lastWeekday(year, 4, 1);
      case "Father's Day": return this.nthWeekday(year, 5, 0, 3);
      case 'Labor Day': return this.nthWeekday(year, 8, 1, 1);
      case "Columbus Day / Indigenous Peoples' Day": return this.nthWeekday(year, 9, 1, 2);
      case 'Thanksgiving Day': return this.nthWeekday(year, 10, 4, 4);
      case 'Black Friday': return this.nthWeekday(year, 10, 4, 4).add(1, 'day');
      default: return null;
    }
  }

  hourCompare(left, right){
    return left.value === right.value;
  }


  addNew(){
    (this.form as FormArray).push(this.formBuilder.group({
      store_id: this.store.id,
      is_open:false,
      holiday_name: [null, Validators.required],
    }))
  }

  delete(i){
    (this.form as FormArray).removeAt(i)
  }
  
  onSubmit(){
    let payload = {
      store_id: this.store.id,
      holiday: this.form.value
    }
    this.storeService.updateHoliday(payload).subscribe(data => {
      this.dialogRef.close()
    })
  }

}
